import { Injectable } from '@angular/core';
import { SealMockApiService } from '@shipsfocus/seal';
import { epanStatuses as epanStatusesData } from 'app/mock-api/ship-shore-operation/pre-arrival-notice/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class PreArrivalNoticeMockApi {
  private _epanStatuses: { id: string; index: number; name: string; slug: string }[] = epanStatusesData;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/ship_shore_operation/pre_arrival_notice/statuses').reply(() => {
      const epanStatuses = cloneDeep(this._epanStatuses);

      return [200, epanStatuses];
    });
  }
}
